<template>
  <div>
    <group-card title="Leads for Auction" icon="shopping_cart">
      <v-card>
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <loading-icon-button @click="fetchAuctionLeads" tooltip="Refresh" :loading="loading">
              refresh
          </loading-icon-button>
          <md-button class="md-primary md-raised" @click="bulkTransfer()" style="margin-right: 10px;">
            Bulk Lead Transfer
          </md-button>
          <md-button class="md-primary md-raised" @click="pushToAuction()">
            Push to Auction
          </md-button>
        </v-card-title>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="auction_lead_basket.applications"
          :items-per-page="20"
          :search="search"
          show-select
          item-key="AppID"
          class="elevation-1"
          :footer-props="{
            itemsPerPageOptions: [10, 20]
          }"
          :custom-filter="customFilter"
        >
          <template v-slot:item.vedascore="{ item }">
            <v-btn
              small
              class="button"
              elevation="2"
              @click="showVedaReportDialog(item)"
              v-if="item.vedascore"
            >
              {{ item.vedascore }}
            </v-btn>
          </template>
          <template v-slot:item.PodID="{ item }">
            <v-btn
              elevation="2"
              small
              @click="viewApplication(item)"
            >
              View
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </group-card>

    <md-dialog :md-active.sync="vedaReportDialog">
      <div class="vedaReportWrapper">
        <veda-summary :veda-report="veda_report" :showFullReportButton="false"/>
      </div>
    </md-dialog>

    <md-dialog :md-active.sync="transferToBrokerDialog">
      <div style="padding: 20px">
        <validated-autocomplete-input
          class="md-layout-item md-size-33"
          :label="`Broker`"
          v-model="choosenBroker"
          required
          :options="brokerNameArray"
          force
        />
        <md-dialog-actions>
          <md-button class="md-primary" @click="confirmBulkTransfer">Confirm</md-button>
          <md-button class="md-primary" @click="closeTransferModel">Cancel</md-button>
        </md-dialog-actions>
      </div>
    </md-dialog>



    <md-dialog-alert
      :md-active.sync="alert_dialog.show"
      :md-title="alert_dialog.title"
      :md-content="alert_dialog.content"
    />
    <loading-dialog :data="loading_alert" />
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import {GroupCard} from "@/components";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";
import LoadingIconButton from '@/components/LoadingIconButton';
import VedaSummary from '@/components/ApplicationSummary/VedaSummary.vue';
import ValidatedNumberInput from "../components/ValidatedInput/ValidatedNumberInput";
import filters from "@/components/utils/filters";
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog";
import LoadingDialog from "@/components/Dialogs/LoadingDialog.vue";
import ValidatedInputs from "@/components/ValidatedInput";

export default {
  components: {
    GroupCard,
    LoadingIconButton,
    LoadingIconTextButton,
    VedaSummary,
    ValidatedNumberInput,
    LoadingDialog,
    ...ValidatedInputs,
  },
  data() {
    return {
      loading: false,
      search: 'D Grade',
      selected: [],
      alert_dialog: {
        show: false,
        content: "",
        title: ""
      },
      loading_alert: {
        message: "",
        show: false,
        title: "",
      },
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'AppID',
        },
        { text: 'Date', value: 'Created' },
        { text: 'Asset', value: 'AssetType' },
        { text: 'Agent', value: 'User' },
        { text: 'Grade', value: 'grade' },
        { text: 'Employment', value: 'Employment' },
        { text: 'Year', value: 'EmploymentYear' },
        { text: 'Month', value: 'EmploymentMonth' },
        { text: 'Ownership', value: 'AddressOwnershipType' },
        { text: 'Status', value: 'Status' },
        { text: 'Veda', value: 'vedascore' },
        { text: 'FinDocs', value: 'HasFinancialDocs' },
        { text: 'LLphone', value: 'HasLandlordPhoneNumber' },
        { text: 'Expense', value: 'HasSomeExpense' },
        { text: 'Summary', value: 'PodID' },
      ],
      vedaReportDialog: false,
      transferToBrokerDialog: false,
      brokerNameArray: [],
      brokerArray: [],
      broker: [],
      choosenBroker: null,
    }
  },
  computed: {
    ...mapGetters([
      "auction_lead_basket",
      "veda_report",
    ]),
  },
  filters: {
    ...filters,
  },
  watch: {
    "choosenBroker"() {
      this.broker = this.brokerArray.find(array => array.full_name === this.choosenBroker);
    },
  },
  methods: {
    async fetchAuctionLeads() {
      this.showLoading("Fetching leads", "Please wait....", true);
      try {
        await this.$store.dispatch('fetch_auction_leads');
      } catch (err) {
        this.showDialogPopup("","Failed to retrieve leads from n8n.");
        console.log(err);
      } finally {
        this.loading_alert.show = false;
      }
    },
    customFilter(value, search, item) {
      // Convert the search value to lowercase for case-insensitive search
      search = search.toLowerCase();
      // Check if any field in the item matches the search value
      for (const key in item) {
        if (item[key] && item[key].toString().toLowerCase().includes(search)) {
          return true; // Return true if a match is found
        }
      }
      return false; // Return false if no match is found
    },
    async showVedaReportDialog(item) {
      try {
        await this.$store.dispatch("fetch_veda_report", {
          loan_application_id: item.AppID,
          is_auction_veda: 1
        });
        this.vedaReportDialog = true;
      } catch(error) {
        console.log(error);
      }
    },
    showDialogPopup(title, message) {
      this.alert_dialog.title = title;
      this.alert_dialog.content = message;
      this.alert_dialog.show = true;
    },
    showConfirmDialog(title, message) {
      return this.$modal.show(ConfirmDialog, {
        title: title,
        message: message,
        confirmText: 'Yes',
        cancelText: 'No',
      });
    },
    closeTransferModel() {
      this.transferToBrokerDialog = false
    },
    viewApplication(item) {
      this.$router.push(`/application/${item.AppID}/summary`);
    },
    showLoading(title, message, flag) {
      this.loading_alert = {
        message: message,
        show: flag,
        title: title,
      };
    },
    async pushToAuction() {
      if (this.selected.length == 0) {
        this.showDialogPopup("","You have not choose any lead.");
        return;
      }
      if (this.selected.length >= 10) {
        this.showDialogPopup("","Please select under 10 leads");
        return;
      }
      let userAnswer = await this.showConfirmDialog("","Do you want to send chosen leads to Auction?");
      if (!userAnswer) {
          return;
      }
      this.showLoading("Moving leads to auction", "Please wait....", true);
      try {
        await axios.post('/api/v1/auction/pushToAuction', { selected : this.selected });
        this.showDialogPopup("","Push to Auction Successfully!");
        this.selected = [];
      } catch (err) {
        console.log(err);
        this.showDialogPopup("","Push to Auction failed.");
      } finally {
        this.loading_alert.show = false;
      }
      this.fetchAuctionLeads();
    },
    async getAllBrokers () {
      try {
        const response = await axios.get('/api/v1/administration/brokers');
        const activeBrokers = response.data.filter(item => item.employment_type === "active");
        this.brokerNameArray = activeBrokers.map(item => item.full_name);
        this.brokerArray = activeBrokers;
      } catch (err) {
        console.log(err);
      }
    },
    async confirmBulkTransfer() {
      let userAnswer = await this.showConfirmDialog("","Do you want to transfer selected leads to".concat(" ", this.choosenBroker));
      if (!userAnswer) {
          return;
      }
      this.showLoading("Transfer leads to".concat(" ", this.choosenBroker), "Please wait....", true);
      try {
        await axios.post('/api/v1/auction/bulkMQLtransferToBroker',
        {
          broker : this.broker,
          selected: this.selected,
        });
        this.showDialogPopup("","Transfer to Broker successfully!");
        this.selected = [];
      } catch (err) {
        console.log(err);
        this.showDialogPopup("","Transfer to Broker failed.");
      } finally {
        this.loading_alert.show = false;
        this.transferToBrokerDialog = false;
      }
      this.fetchAuctionLeads();
    },
    async bulkTransfer() {
      if (this.selected.length == 0) {
        this.showDialogPopup("","You have not choose any lead.");
        return;
      }
      if (this.selected.length > 20) {
        this.showDialogPopup("","Please select under 20 leads");
        return;
      }
      let i = 0;
      while (i < this.selected.length) {
          if (this.selected[i].grade !== "D Grade") {
              this.showDialogPopup("", "Only allow to bulk transfer MQL Leads (Grade D)");
              return;
          }
          i++;
      }
      this.transferToBrokerDialog = true;
      return;
    }
  },
  async created() {
     await this.fetchAuctionLeads();
     await this.getAllBrokers();
  },
};
</script>
<style scoped lang="scss">
.lead-table {
  margin: 0;
  max-height: 100vw;
  overflow: scroll;
  overflow-y: hidden;
}
.md-table-pagination {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
}
.action-buttons-cover{
  float: left;
  margin-top: 50px;
  width: 100%;
}
.message-ul{
  padding-left: 100px;
  padding-right: 100px;
}
.side-header{
  font-size: 1.25rem;
}
.message-height{
  line-height: 2rem;
}
.font-bold{
  font-weight: bold;
}
.dialogWrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: auto;
  width: auto;
  min-width: 20vw;
  max-width: 40vw;
  padding: 20px;
  form {
    div {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 2px;
    }
  }
}
.vedaReportWrapper {
  min-width: 60vw;
}
.ba-check {
  color: rgb(71, 67, 67);
  &.has_ba_options {
    color: rgb(23, 179, 23)  !important;
  }
}
.doc-check {
  color: rgb(71, 67, 67);
  &.has_documents {
    color: rgb(23, 179, 23) !important;
  }
}
.button {
  color: #fff !important;
  background: #2e3485 !important;
}
</style>
